import { useQuery } from '@tanstack/react-query';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';
import { useUser } from '../auth/AuthProvider';

export interface EffectivenessReport {
  windowDays: number;
  summary: {
    totalCalls: number;
    bookedCalls: number;
    conversionPct: number;
    avgLatencyP50Ms: number;
    avgLatencyP95Ms: number;
    fillerInjectionsPer100Calls: number;
    totalCostUsd: number;
    llmTokensIn: number;
    llmTokensOut: number;
    mirrorEventCount: number;
    mirrorAiBookedCount: number;
    mirrorVerifiedCount: number;
    totalCallSeconds: number;
    totalCallMinutes: number;
    ticketsTotal: number;
    ticketsOpen: number;
  };
  perEventType: Array<{
    eventTypeId: string;
    name: string;
    plannedMinutes: number;
    bookedCount: number;
    avgActualMinutes: number | null;
    avgEffectivenessScore: number | null;
  }>;
  perLlm: Array<{
    provider: string;
    model: string;
    callCount: number;
    conversionPct: number;
    avgCostUsd: number;
  }>;
  heatmap: number[][];
  daily: Array<{ day: string; calls: number; booked: number; latencyP50: number; latencyP95: number }>;
}

export function useEffectiveness(days = 30) {
  const { user } = useUser();
  return useQuery<EffectivenessReport>({
    queryKey: ['effectiveness', days],
    enabled: !!user,
    staleTime: 60_000,
    queryFn: async () => {
      const fn = httpsCallable<{ days: number }, EffectivenessReport>(
        functions,
        'getEffectivenessReport',
      );
      const r = await fn({ days });
      return r.data;
    },
  });
}
